module.exports = __webpack_public_path__ + "static/media/factorygrid.894a02af.mp4";